import { render, staticRenderFns } from "./ObrasConsulta.vue?vue&type=template&id=bb98ddf0&"
import script from "./ObrasConsulta.vue?vue&type=script&lang=js&"
export * from "./ObrasConsulta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports